/*
    Module definition for browserify
*/
require('./dist/filepicker');
module.exports = filepicker;
